import { useCallback, useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import api from "@/lib/api";
import { PageHeader } from "@/components/common/PageHeader";
import { SurfaceCard } from "@/components/common/Cards";
import { StatusBadge } from "@/components/common/StatusBadge";
import { ConsentSignatures } from "@/components/common/ConsentSignatures";
import { Loader2 } from "lucide-react";
import { toast } from "sonner";

export default function ConsentDocument() {
  const { id } = useParams();
  const navigate = useNavigate();
  const [c, setC] = useState(null);
  useEffect(() => { api.get(`/consents/${id}`).then((r) => setC(r.data)).catch(() => { toast.error("Consent not found"); navigate(-1); }); }, [id, navigate]);
  const onChange = useCallback((d) => setC(d), []);
  if (!c) return <div className="flex h-[50vh] items-center justify-center"><Loader2 className="h-6 w-6 animate-spin text-[#00A85A]" /></div>;
  return (
    <div className="mx-auto max-w-4xl" data-testid="consent-document-page">
      <PageHeader title={c.title} subtitle={`${c.patient_name} · ${c.doctor_name || ""}`} breadcrumb={["Patients", "Consent"]}
        actions={<StatusBadge status={c.status === "signed" ? "success" : "warning"} label={c.status === "signed" ? "Signed" : "Awaiting signature"} />} />
      <SurfaceCard className="p-6">
        <div className="space-y-5" data-testid="consent-document-text">
          {(c.sections || []).map((s, i) => (
            <div key={i}>
              <div className="mb-1.5 text-sm font-bold text-[#101516] dark:text-white">{s.heading}</div>
              {s.text && <p className="text-sm leading-relaxed text-[#3a4a4f] dark:text-[#B7C3C7]">{s.text}</p>}
              {(s.items || []).length > 0 && <ul className="space-y-1">{s.items.map((it, x) => <li key={x} className="flex gap-2 text-sm text-[#3a4a4f] dark:text-[#B7C3C7]"><span className="text-[#00A85A]">•</span>{it}</li>)}</ul>}
            </div>
          ))}
        </div>
        <div className="mt-8 border-t border-[#E2E8F0] pt-6 dark:border-[#223139]"><ConsentSignatures consent={c} onChange={onChange} /></div>
      </SurfaceCard>
    </div>
  );
}
